import React, { useState } from "react";
import AIAutomationChat from "../components/AIAutomationChat";

const AIAutomationOptionA = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);


    return (
        <div className="font-sans text-gray-900 bg-black min-h-screen relative overflow-hidden">
            {/* Modal Video Player */}
            {isModalOpen && (
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/90 backdrop-blur-sm p-4 animate-fade-in">
                    <div className="relative w-full max-w-5xl aspect-video bg-black rounded-2xl overflow-hidden shadow-2xl border border-gray-800">
                        <button
                            onClick={closeModal}
                            className="absolute top-4 right-4 z-60 text-white/70 hover:text-white bg-black/50 hover:bg-black/80 rounded-full p-2 transition-all"
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-8 h-8">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                            </svg>
                        </button>
                        <video
                            src="/DocLift-V2.2.mp4"
                            controls
                            autoPlay
                            className="w-full h-full object-contain"
                        />
                    </div>
                </div>
            )}

            {/* Hero Section */}
            <section className="relative h-screen w-full flex flex-col items-center justify-center text-center px-4 overflow-hidden">

                {/* Background Image / Gradient */}
                <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-purple-900 to-black z-0">
                    {/* Optional: Add a subtle texture or abstract shapes here if desired */}
                    <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1639322537228-ad714dd474f9?q=80&w=2664&auto=format&fit=crop')] bg-cover bg-center opacity-20 mix-blend-overlay"></div>
                </div>

                {/* Content Container */}
                <div className="relative z-10 max-w-4xl mx-auto animate-fade-in-up">
                    <h1 className="text-5xl md:text-7xl font-extrabold text-white tracking-tighter mb-6 drop-shadow-lg">
                        Automate. Innovate. Elevate.
                    </h1>
                    <p className="text-xl md:text-2xl text-gray-200 mb-12 max-w-2xl mx-auto drop-shadow-md">
                        The next generation of AI-powered business automation is here. Watch how we transform operations.
                    </p>

                    {/* Play Button */}
                    <button
                        onClick={openModal}
                        className="group relative inline-flex items-center justify-center w-24 h-24 bg-white/10 hover:bg-white/20 backdrop-blur-md border border-white/30 rounded-full transition-all duration-300 hover:scale-110 shadow-[0_0_30px_rgba(168,85,247,0.5)] hover:shadow-[0_0_50px_rgba(168,85,247,0.8)]"
                    >
                        <div className="absolute inset-0 rounded-full border border-white/20 animate-ping opacity-75"></div>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-10 h-10 text-white ml-1 group-hover:text-purple-400 transition-colors">
                            <path fillRule="evenodd" d="M4.5 5.653c0-1.426 1.529-2.33 2.779-1.643l11.54 6.348c1.295.712 1.295 2.573 0 3.285L7.28 19.991c-1.25.687-2.779-.217-2.779-1.643V5.653z" clipRule="evenodd" />
                        </svg>
                    </button>

                    <div className="mt-6 text-gray-300 text-sm tracking-widest uppercase font-semibold">
                        Watch the Film
                    </div>

                    <div className="mt-12 flex gap-4 justify-center">
                        <button className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-full font-bold text-lg shadow-lg hover:shadow-blue-500/30 transition-all transform hover:-translate-y-1">
                            Book a Demo
                        </button>
                        <button className="bg-transparent border border-white/30 hover:bg-white/10 text-white px-8 py-3 rounded-full font-bold text-lg backdrop-blur-sm transition-all">
                            Learn More
                        </button>
                    </div>
                </div>
            </section>

            {/* Services Section (Reused content for context) */}
            <section className="py-24 px-8 bg-gray-950 text-white relative z-10">
                <div className="max-w-6xl mx-auto">
                    <h2 className="text-3xl md:text-5xl font-bold text-center mb-16 bg-gradient-to-r from-blue-400 to-purple-500 text-transparent bg-clip-text">
                        Why Choose Us?
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                        {[
                            { title: "24/7 Availability", icon: "🕒", desc: "Your business never sleeps with our always-on AI agents." },
                            { title: "Seamless Integration", icon: "🔗", desc: "Connects effortlessly with your existing CRM and tools." },
                            { title: "Data-Driven Insights", icon: "📊", desc: "Make smarter decisions with real-time analytics and reporting." }
                        ].map((item, idx) => (
                            <div key={idx} className="bg-gray-900 border border-gray-800 p-8 rounded-2xl hover:border-purple-500/50 transition-all hover:shadow-2xl hover:shadow-purple-900/20">
                                <div className="text-4xl mb-4">{item.icon}</div>
                                <h3 className="text-xl font-bold mb-3">{item.title}</h3>
                                <p className="text-gray-400">{item.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Chat Component */}
            <AIAutomationChat />
        </div>
    );
};

export default AIAutomationOptionA;
